const safelist = ['object-contain', 'object-cover', 'object-fill', 'object-scale-down', 'object-none'];

module.exports = safelist;
